import { render } from "./StakeholderSelectionComponent.vue?vue&type=template&id=50fe1229"
import script from "./StakeholderSelectionComponent.vue?vue&type=script&lang=js"
export * from "./StakeholderSelectionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__